export const badgeStandard = {
  bg: 'yellow20',
  label: '401(k)',
};
